import { useEffect, useRef, MutableRefObject } from 'react'
import { Lightbox } from '@components/Lightbox'
import { styled } from 'twin.macro'
import AutosaveStatusHeader from '../_shared/AutosaveStatusHeader'

type Props = {
  close: () => void
  containerRef: MutableRefObject<HTMLDivElement>
}

const TextInputLightbox = (props: Props) => {
  const { close, containerRef } = props
  const mainRef = useRef<HTMLDivElement>()

  const headerContent = <AutosaveStatusHeader title="編輯文章內容" close={close} />

  const mainContent = <Main tw="space-y-4" ref={mainRef} />

  useEffect(() => {
    const container = containerRef.current
    const childNodes = Array.from(container.childNodes).slice(1)
    const main = mainRef.current
    childNodes.forEach((node) => main.append(node))

    return () => childNodes.forEach((node) => container.append(node))
  }, [])

  return <Lightbox close={close} headerContent={headerContent} mainContent={mainContent} />
}

const Main = styled.div`
  padding: 16px 8px;
`

export default TextInputLightbox
